import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import LoadingSpinner from "../../packs/loading_spinner";
import axios from "axios";
import i18next from "i18next";
import notify from "../../packs/notify";

const sequenceInputSelector = '[data-portal--submission-predefined-test-results-target="sequenceNumberInput"]'
const wrapperSelector = '[data-portal--submission-predefined-test-results-target="answerGroup"]'
export default class extends NestedForm {
  static targets = ["paginationContainer", "sequenceNumberInput", "dateInput", "multipleCheckboxesString"]
  static values = {}

  connect() {
    $('.selectpicker').selectpicker();
  }

  paginationContainerTargetConnected(element) {
    element.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        this.handlePaginationLinkVisit(e)
      })
    })
  }

  handlePaginationLinkVisit(e) {
    // Parse the URL
    e.preventDefault()
    const url = new URL(e.currentTarget.href).href
    this.dispatch("submit", { detail: { url: url } })
  }

  handleMultipleCheckboxes(e) {
    const specimenTestScheduleId = e.target.dataset.specimenTestScheduleId
    const testResultDefinitionId = e.target.dataset.testResultDefinitionId
    const multipleCheckboxesString = document.querySelector(`[data-specimen-test-schedule-id="${specimenTestScheduleId}"][data-test-result-definition-id="${testResultDefinitionId}"][data-answer-data-type="multipleCheckboxes"]`)
    const inputName = e.target.name
    const elements = document.querySelectorAll(`input[name="${inputName}"]`)
    const values = []

    elements.forEach(element => {
      if (element.value.trim() !== '' && element.checked) {
        values.push(element.value)
      }
    })

    multipleCheckboxesString.value = values.join(',')
  }

  remove(e) {
    const predefinedTestResultId = e.currentTarget.dataset.predefinedTestResultId;
    const r = e.target.closest('.nested-form-wrapper')
    if (predefinedTestResultId) {
      this.deletePredefinedTestResult(e).then(() => {
        r.nextElementSibling.remove() // remove hidden id field
        r.remove()
      })
    } else {
      r.remove()
    }
  }

  dateInputTargetConnected(element) {
    $('.bootstrap-datepicker').datepicker({
      autoclose: true,
      todayHighlight: true
    });
    globalDateValidation('predefined_test_results_form', true)
  }

  addNew(e) {
    const wrapper = e.currentTarget.closest(wrapperSelector)
    const sequenceNumberInputs = wrapper.querySelectorAll(sequenceInputSelector)
    // Update sequence number
    sequenceNumberInputs[sequenceNumberInputs.length - 1].value = parseInt(sequenceNumberInputs[sequenceNumberInputs.length - 2].value) + 1
  }

  async deletePredefinedTestResult(e) {
    LoadingSpinner("show")
    let id = e.currentTarget.dataset.predefinedTestResultId
    let url = '/pre_defined_test_results/' + id + '.json'
    axios({
      url: url,
      method: 'DELETE',
    })
      .then(res => {
        LoadingSpinner("hide")
        const msg = i18next.t('Test criteria has been deleted!')
        notify({
          message: msg,
          status: "success"
        })
      })
      .catch((error) => {
        LoadingSpinner("hide")
        const msg = i18next.t('Test criteria has been deleted!')
        notify({
          message: msg + " : " + error,
          status: "error"
        })
      })
  }
}
